module.exports = __webpack_public_path__ + "img/cjl.5a68f97c.png";